export default __webpack_public_path__ + "static/media/yampi.b1a534f0.svg";